require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./context"), require("./svgicon"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./context", "./svgicon", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./context"), require("./svgicon"), require("./utils")) : factory(root["./button"], root["./context"], root["./svgicon"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__14935__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[8802],{

/***/ 11364:
/***/ ((module) => {

var amdi18n={"__root":{"close":"Close"},"__cs":{"close":"Zavřít"},"__da":{"close":"Luk"},"__de":{"close":"Schließen"},"__es":{"close":"Cerrar"},"__fi":{"close":"Sulje"},"__fr":{"close":"Fermer"},"__hr":{"close":"Zatvori"},"__hu":{"close":"Bezárás"},"__it":{"close":"Chiudi"},"__ja":{"close":"閉じる"},"__kk":{"close":"Жабу"},"__ko":{"close":"닫기"},"__nb":{"close":"Lukk"},"__nl":{"close":"Sluiten"},"__no":{"close":"Lukk"},"__pl":{"close":"Zamknij"},"__pt":{"close":"Fechar"},"__pt-br":{"close":"Fechar"},"__ro":{"close":"Închidere"},"__ru":{"close":"Закрыть"},"__sl":{"close":"Zapri"},"__sv":{"close":"Stäng"},"__th":{"close":"ปิด"},"__tr":{"close":"Kapat"},"__zh":{"close":"关闭"},"__zh-cn":{"close":"关闭"},"__zh-hk":{"close":"關閉"},"__zh-mo":{"close":"關閉"},"__zh-sg":{"close":"关闭"},"__zh-tw":{"close":"關閉"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 29979:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = exports.ThemedDialog = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _reactDom = __webpack_require__(66405);
var _utils = __webpack_require__(78815);
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _close_ = _interopRequireDefault(__webpack_require__(82471));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _context = __webpack_require__(14935);
var _Dialog = _interopRequireDefault(__webpack_require__(56805));
var _StringResource = _interopRequireDefault(__webpack_require__(85164));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  enableFocusLoop,
  disableFocusLoop,
  resetFocusLoop
} = _utils.domUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;
const {
  assign,
  uniqueId
} = _utils.lodash;
const {
  sanitize
} = _utils.propsUtils;
const dialogClassName = _Dialog.default.dialogClassName.replace(/"/g, '');
function createIcon(icon) {
  if (!icon) {
    return null;
  }
  const iconComponent = typeof icon === 'string' ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    focusable: false,
    iconId: icon
  }) : icon;
  return iconComponent;
}
function Header(props) {
  const {
    children,
    title,
    ...others
  } = props;
  if (typeof children === 'string') {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, others, {
      key: "Header",
      className: `${dialogClassName}__header`
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: `${dialogClassName}__title __header_overflow`,
      role: "heading",
      title: title || children
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, others, {
    key: "Header",
    className: `${dialogClassName}__header`
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `${dialogClassName}__title`
  }, children));
}
Header.propTypes = {
  children: _propTypes.default.node,
  title: _propTypes.default.string
};
function SubHeader(props) {
  const {
    children,
    title,
    size,
    ...others
  } = props;
  if (typeof children === 'string') {
    return size !== 'small' && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, others, {
      className: `${dialogClassName}__subtitle __header_overflow`,
      title: title || children
    }), children);
  }
  return size !== 'small' && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, others, {
    className: `${dialogClassName}__subtitle`
  }), children);
}
SubHeader.propTypes = {
  children: _propTypes.default.node,
  size: _propTypes.default.string,
  title: _propTypes.default.string
};
function Button(props) {
  const {
    primary,
    ...others
  } = props;
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    tabIndex: 0,
    button: true,
    set: primary ? 'primary' : 'tertiary',
    title: ""
  }, others));
}
Button.propTypes = {
  label: _propTypes.default.string,
  primary: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
function Body(props) {
  const {
    children,
    ...others
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, others, {
    className: `${dialogClassName}__content`
  }), children);
}
Body.propTypes = {
  children: _propTypes.default.node
};
function Footer(props) {
  const {
    children,
    ...others
  } = props;
  const footerChildren = [];
  let hasNonButtonChild = false;
  let primaryIndex;

  // sort through footer children to search for buttons and assign kind
  _react.default.Children.forEach(children, child => {
    if (child) {
      let footerChild = child;
      if (child.type === Button) {
        if (child.props.primary) {
          primaryIndex = footerChildren.length;
        } else {
          footerChild = _react.default.cloneElement(child, {
            set: 'secondary'
          });
        }
      } else if (!hasNonButtonChild) {
        hasNonButtonChild = true;
      }
      footerChildren.push(footerChild);
    }
  });

  // move primary button to be the last child
  primaryIndex >= 0 && footerChildren.push(footerChildren.splice(primaryIndex, 1)[0]);
  let classNames = `${dialogClassName}__footer`;
  if (footerChildren.length) {
    if (footerChildren.length === 2 && !hasNonButtonChild) {
      classNames = (0, _utils.classnames)(classNames, {
        transactional: true
      });
    } else {
      classNames = (0, _utils.classnames)(classNames, {
        progress: true
      });
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    "data-tid": "ba-common-dialog__footer"
  }, others, {
    className: classNames
  }), footerChildren);
}
Footer.propTypes = {
  children: _propTypes.default.node
};
function getString(value) {
  return _StringResource.default.get(value);
}
class Dialog extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_id", uniqueId('ba-common-dialog__'));
    (0, _defineProperty2.default)(this, "modal", _react.default.createRef());
    (0, _defineProperty2.default)(this, "closeNode", _react.default.createRef());
    (0, _defineProperty2.default)(this, "_setEventDialogProp", e => {
      e.eventDialog = true;
    });
    (0, _defineProperty2.default)(this, "_onMenuKeyDown", e => {
      this.modal.current.removeAttribute('hiddenOutline');
      if (this.props.onClose && isKey(e, keyNames.ESCAPE)) {
        e.preventDefault();
        this.props.onClose(e);
      }
    });
    (0, _defineProperty2.default)(this, "_clickawayHandler", e => {
      if (this.props.onClose && this.props.clickaway && !this.blockerCell.contains(e.target) && e.target === this.dialogWrapper) {
        this.props.onClose(e);
      }
    });
    (0, _defineProperty2.default)(this, "_validMinWidth", minWidth => {
      const minWidthValue = minWidth.match(/\d+/);
      if (minWidth.indexOf('%') >= 0 && minWidthValue > 100) {
        return false;
      }
      if (minWidth.indexOf('px') >= 0 && minWidthValue <= 400) {
        return false;
      }
      return true;
    });
    (0, _defineProperty2.default)(this, "_sortChildren", children => {
      // Sort the child nodes in dialog in following order:
      const ref = ['SubHeader', 'Header', 'Body', 'Footer'];

      // It's possible that a dialog doesn't contain all 4 elements
      // Swap-sorting cannot be used here due to incontinuous indexes

      // Pruning first (with/without SubHeader)
      if (children.filter((el, i) => el.type.name === ref[i] || el.type.name === ref[i + 1]).length === children.length) {
        return children;
      }

      // TODO: Find a better sorting algorithm here
      ref.forEach(name => {
        for (let i = 0; i < children.length; i++) {
          if (children[i].type.name === name) {
            const temp = children[i];
            children.splice(i, 1);
            children.push(temp);
            break;
          }
        }
      });
      return children;
    });
  }
  componentDidMount() {
    const {
      startingFocusIndex,
      ariaLabel
    } = this.props;
    document.body.style.overflow = 'hidden';
    enableFocusLoop(this.blockerCell, startingFocusIndex, ariaLabel);
    this.node.addEventListener('click', this._setEventDialogProp);
    this.node.addEventListener('touchStart', this._setEventDialogProp);
  }
  componentDidUpdate() {
    resetFocusLoop(this.blockerCell);
  }
  componentWillUnmount() {
    document.body.style.overflow = '';
    disableFocusLoop(this.blockerCell);
    this.node.removeEventListener('click', this._setEventDialogProp);
    this.node.removeEventListener('touchStart', this._setEventDialogProp);
  }
  render() {
    const {
      size,
      width,
      minWidth,
      maxWidth,
      theme,
      getLocaleString,
      className,
      style,
      ...others
    } = this.props;
    const icon = createIcon(`${_close_.default.id}`);
    let children = null;
    if (this.props.children && Array.isArray(this.props.children)) {
      const modalElements = this._sortChildren([...this.props.children]);
      children = _react.default.Children.map(modalElements, child => _react.default.cloneElement(child, {
        size
      }));
    } else {
      children = _react.default.Children.map(this.props.children, child => _react.default.cloneElement(child, {
        size
      }));
    }
    const validMinWidth = minWidth && this._validMinWidth(minWidth) && minWidth;
    const blockerMenuStyle = {
      width,
      maxWidth
    };
    const modalMenuStyle = {
      minWidth: validMinWidth
    };
    return (0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
      className: `${theme}`,
      ref: node => {
        this.node = node;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: ref => {
        this.dialogWrapper = ref;
      },
      onClick: this._clickawayHandler,
      onKeyDown: this._onMenuKeyDown,
      className: `${dialogClassName} ${className}`,
      style: style
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: blockerMenuStyle,
      ref: ref => {
        this.blockerCell = ref;
      },
      "data-tid": "ba-common-dialog__blocker",
      className: `${dialogClassName}__blockerCell`
    }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      style: modalMenuStyle
    }, sanitize(others, Dialog), {
      role: "dialog",
      "aria-modal": "true",
      ref: this.modal,
      tabIndex: "-1",
      className: `${dialogClassName}__modal ${(size === 'small' || size === 'large' || size === 'xlarge') && !width ? (0, _utils.classnames)(size) : ''}`
    }), children, this.props.onClose && /*#__PURE__*/_react.default.createElement("span", {
      ref: this.closeNode,
      className: `${dialogClassName}__closeX`
    }, /*#__PURE__*/_react.default.createElement(Button, {
      "data-tid": "ba-common-dialog__close-x",
      icon: icon,
      variant: "icon",
      title: getLocaleString('close'),
      onClick: this.props.onClose,
      "aria-label": getLocaleString('close')
    })))))), document.body);
  }
}
(0, _defineProperty2.default)(Dialog, "propTypes", {
  /** Choose from two fixed sizes */
  size: _propTypes.default.oneOf(['small', 'large', 'xlarge']),
  /** Custom width in px or % */
  width: _propTypes.default.string,
  /** Custom min width in px or % */
  minWidth: _propTypes.default.string,
  /** Custom max width in px or % */
  maxWidth: _propTypes.default.string,
  /** Close dialog on clicking outside */
  clickaway: _propTypes.default.bool,
  /** Header, SubHeader, Body and Footer inside the dialog */
  children: _propTypes.default.node,
  /** Callback function when dialog is closed */
  onClose: _propTypes.default.func,
  /** Custom style theme */
  theme: _propTypes.default.string,
  /** Get Locale */
  getLocaleString: _propTypes.default.func,
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Custom CSS styles */
  style: _propTypes.default.object,
  /** Non-negative value sets the focus at the target node index */
  startingFocusIndex: _propTypes.default.number,
  /** aria-label string for initially focused div */
  ariaLabel: _propTypes.default.string
});
(0, _defineProperty2.default)(Dialog, "defaultProps", {
  clickaway: false,
  theme: 'ba-theme-default',
  getLocaleString: getString,
  className: '',
  style: {},
  startingFocusIndex: -1
});
var _default = exports["default"] = assign(Dialog, {
  Header,
  SubHeader,
  Body,
  Footer,
  Button
});
const ThemedDialog = exports.ThemedDialog = assign((0, _context.withContext)('theme')(Dialog), {
  Header,
  SubHeader,
  Body,
  Footer,
  Button
});

/***/ }),

/***/ 72027:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Dialog = _interopRequireDefault(__webpack_require__(29979));
exports["default"] = _Dialog.default;
exports.Dialog = _Dialog.default;

/***/ }),

/***/ 85164:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _DialogResources = _interopRequireDefault(__webpack_require__(11364));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_DialogResources.default);

/***/ }),

/***/ 44969:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-dialog{position:fixed;top:0;left:0;bottom:0;right:0;z-index:9000;display:flex;overflow-y:auto;overflow-x:hidden;padding:32px 0;background-color:rgba(22,22,22,.5);background-color:hsla(var(--overlay-01-h, 0), var(--overlay-01-s, 0%), var(--overlay-01-l, 8.6274509804%), 0.5)}.ba-common-dialog__blockerCell{visibility:visible;position:relative;height:auto;margin:auto;z-index:9000;text-align:center;display:flex;align-self:flex-start;align-items:center;justify-content:center;min-width:400px;max-width:calc(100% - 64px)}.ba-common-dialog__modal{display:inline-flex;background-color:#fff;flex-direction:column;text-align:left;position:relative;width:100%;padding:1rem 0 0 0}.ba-common-dialog__modal.is-small{width:450px;max-height:240px}.ba-common-dialog__modal.is-small .ba-common-dialog__content{overflow:auto;min-height:72px;max-height:72px}.ba-common-dialog__modal.is-large{width:680px;max-height:496px}.ba-common-dialog__modal.is-large .ba-common-dialog__content{overflow:auto;max-height:300px}.ba-common-dialog__modal.is-xlarge{width:700px;max-height:800px}.ba-common-dialog__modal.is-xlarge .ba-common-dialog__content{overflow:auto;max-height:600px}.ba-common-dialog__modal:focus{outline:0}.ba-common-dialog__header{color:#161616;height:auto;font-size:1.25rem;font-weight:400;line-height:1.75rem;letter-spacing:0;padding-left:1rem;margin-bottom:16px;max-width:calc(100% - 48px)}[dir=ltr].ba-common-dialog__header{padding-right:1rem;text-align:left}[dir=rtl].ba-common-dialog__header{padding-right:0;padding-left:1rem;text-align:right}[dir=ltr] .ba-common-dialog__header,.ba-common-dialog__header{padding-right:1rem;text-align:left}[dir=rtl] .ba-common-dialog__header{padding-right:0;padding-left:1rem;text-align:right}.ba-common-dialog__subtitle{font-size:.75rem;font-weight:400;line-height:1rem;letter-spacing:.32px;color:#525252;padding-left:1rem;margin-bottom:.25rem}[dir=ltr].ba-common-dialog__subtitle{text-align:left}[dir=rtl].ba-common-dialog__subtitle{text-align:right}[dir=ltr] .ba-common-dialog__subtitle,.ba-common-dialog__subtitle{text-align:left}[dir=rtl] .ba-common-dialog__subtitle{text-align:right}.ba-common-dialog .__header_overflow{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;line-height:normal}.ba-common-dialog__closeX{position:absolute;margin:0;cursor:pointer;background-color:transparent;top:0}[dir=ltr].ba-common-dialog__closeX{right:0}[dir=rtl].ba-common-dialog__closeX{right:auto;left:0}[dir=ltr] .ba-common-dialog__closeX,.ba-common-dialog__closeX{right:0}[dir=rtl] .ba-common-dialog__closeX{right:auto;left:0}.ba-common-dialog__closeX:hover{background-color:#e5e5e5}.ba-common-dialog__closeX:focus{outline:none;border-color:#a8c0f3}.ba-common-dialog__content{font-size:.875rem;font-weight:400;line-height:1.25rem;letter-spacing:.16px;position:relative;line-height:1.25rem;color:#161616;flex:1 1 auto;height:100%;margin-bottom:48px;padding-right:1rem;padding-left:1rem}[dir=ltr].ba-common-dialog__content{text-align:left}[dir=rtl].ba-common-dialog__content{text-align:right}[dir=ltr] .ba-common-dialog__content,.ba-common-dialog__content{text-align:left}[dir=rtl] .ba-common-dialog__content{text-align:right}.ba-common-dialog__content:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.ba-common-dialog__footer{border:none;display:flex;justify-content:flex-end;align-items:flex-end;margin-top:auto;height:4rem}.ba-common-dialog__footer.is-progress:not(button){padding-left:1rem}.ba-common-dialog__footer.is-progress button{flex:0 1 25%;max-width:none;height:4rem;margin:0;padding-top:1rem;padding-bottom:2rem}.ba-common-dialog__footer.is-progress button:not(:first-child){margin-left:1px}.ba-common-dialog__footer.is-transactional button{flex:0 1 50%;max-width:none;height:4rem;margin:0;padding-top:1rem;padding-bottom:2rem}.ba-common-dialog__footer.is-transactional button:not(:first-child){margin-left:1px}.ba-common-dialog__footer.errorDialog{display:flex;justify-content:center;padding:0;height:auto}.ba-common-dialog__footer:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.ba--highContrast .ba-common-dialog__modal{border:1px solid currentColor}.ba-common-dialog__modal[hiddenOutline] .is-focus{outline:none}.ba-common-dialog__blockerCell{color:#343334}.ba-common-dialog__modal{border-top-color:#002d9c;border-top-color:hsla(var(--active-primary-h, 222.6923076923), var(--active-primary-s, 100%), var(--active-primary-l, 30.5882352941%), 1)}@media screen and (-ms-high-contrast: active){.ba-common-dialog__modal{border-left:1px solid #fff;border-right:1px solid #fff;border-bottom:1px solid #fff}}", ""]);

// exports
exports.locals = {
	"dialogClassName": "\"ba-common-dialog\""
};

/***/ }),

/***/ 56805:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44969);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Dialog_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 82471:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/close_32");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 66405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 14935:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__14935__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(72027));
/******/ return __webpack_exports__;
/******/ }
]);
});